import * as React from 'react';
import type { HubConnection } from '@microsoft/signalr';
// import { ErrorBoundary } from "react-error-boundary";
import { QueryClientProvider } from 'react-query';
import { queryClient } from '@/lib/react-query';
import { configureSignalRConnection, logSignalRError } from '@/lib/signalr';
import { ThemeProvider } from './theme';
import { TooltipProvider } from '@/components/ui/tooltip';
import { HUB_URL } from '@/config';
import { createSignalRContext } from 'react-signalr/signalr';

const SignalRContext = createSignalRContext();

// const ErrorFallback = () => {
//   return (
//     <div className="text-red-500 w-screen h-screen flex flex-col justify-center items-center" role="alert">
//       <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
//       <Button size="sm" className="mt-4" onClick={() => window.location.assign(window.location.origin)}>
//         Refresh
//       </Button>
//     </div>
//   );
// };

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <TooltipProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient} contextSharing>
          <SignalRContext.Provider
            logMessageContent
            automaticReconnect
            onOpen={(connection: HubConnection) => {
              configureSignalRConnection(connection);
            }}
            onReconnect={(connection: HubConnection) => {
              configureSignalRConnection(connection);
              console.info('[SignalR] Admin hub reconnected');
            }}
            onClosed={(error?: Error) => {
              logSignalRError('Admin hub closed', error);
            }}
            onError={async (error?: Error) => {
              logSignalRError('Admin hub connection error', error);
            }}
            connectEnabled
            url={HUB_URL}
          >
            {children}
          </SignalRContext.Provider>
        </QueryClientProvider>
      </ThemeProvider>
    </TooltipProvider>
  );
};

export { SignalRContext };
